import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a81f867"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-wrapper print-page" }
const _hoisted_2 = {
  id: "graphPrintHeader",
  class: "print-only chart-print-header"
}
const _hoisted_3 = {
  key: 0,
  id: "loadingLayer"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { id: "chartContainer" }

import { computed, ref, watch } from 'vue'
import moment from 'moment'
import { camelCase } from 'lodash'
import ChartHeader from '@/components/graph/ChartHeader.vue'
import ChartPanel from '@/components/graph/ChartPanel.vue'
import StationSelector from '@/components/graph/StationSelector.vue'
import FieldSelector from '@/components/graph/FieldSelector.vue'
import { useChartConfigStore } from '@/stores/chartConfigStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { GraphTypeField } from '@/lib/graph/types/graphData'
import { StationListItem } from '@/models/InitData'
import { Option } from '@/components/common/MultiSelectModal.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const initDataStore = useInitDataStore()
const getDefaultCenter = () => {
  return moment()
    .set('hour', Math.floor(moment().hour() / 8) * 8 + 4)
    .startOf('hour')
    .toDate()
    .getTime()
}
const firstFieldListItem = initDataStore.initData?.definitionInfo.graph.common.listItems.items[0].items[0].items[0]
const defaultSelectedField = {
  selectedId: camelCase(firstFieldListItem.target),
  reportType: firstFieldListItem.type,
  title: firstFieldListItem.title,
}
const store = useChartConfigStore()
const selectedStations = ref<StationListItem[]>([])
const selectedField = ref<Partial<GraphTypeField>>(defaultSelectedField)
const selectedFields = ref<Option[]>([])
const center = ref(getDefaultCenter())
const modal = ref(false)
const graph = ref()
const showWindRateCount = ref(false)
const loading = computed(() => store.loading)
const options = computed(() => {
  const items = selectedField.value.items

  if (items === undefined) {
    return []
  }

  return items.map(item => ({
    value: camelCase(item.target),
    label: item.title,
    unit: item.unit,
  }))
})

// 多要素グラフかどうか
const isWeatherGraph = computed(() => {
  return selectedField.value.stationId !== undefined
})

const toggleWindRateCount = () => {
  showWindRateCount.value = !showWindRateCount.value
}

watch(
  () => isWeatherGraph.value,
  () => {
    selectedFields.value = options.value
  }
)

watch(
  () => selectedField.value,
  () => {
    showWindRateCount.value = false
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
      [_vShow, !_unref(loading)]
    ]),
    _createVNode(ChartHeader, {
      center: center.value,
      "onUpdate:center": _cache[0] || (_cache[0] = ($event: any) => ((center).value = $event)),
      field: selectedField.value,
      "onUpdate:field": _cache[1] || (_cache[1] = ($event: any) => ((selectedField).value = $event)),
      onToggleWindRateCount: toggleWindRateCount
    }, null, 8, ["center", "field"]),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (selectedStations.value.length > 0)
        ? (_openBlock(), _createBlock(ChartPanel, {
            key: 0,
            ref_key: "graph",
            ref: graph,
            center: center.value,
            "onUpdate:center": _cache[2] || (_cache[2] = ($event: any) => ((center).value = $event)),
            field: selectedField.value,
            stations: selectedStations.value,
            fields: selectedFields.value,
            modal: modal.value,
            showWindRateCount: showWindRateCount.value
          }, null, 8, ["center", "field", "stations", "fields", "modal", "showWindRateCount"]))
        : _createCommentVNode("", true),
      (!_unref(isWeatherGraph))
        ? (_openBlock(), _createBlock(StationSelector, {
            key: 1,
            stations: selectedStations.value,
            "onUpdate:stations": _cache[3] || (_cache[3] = ($event: any) => ((selectedStations).value = $event)),
            modal: modal.value,
            "onUpdate:modal": _cache[4] || (_cache[4] = ($event: any) => ((modal).value = $event)),
            field: selectedField.value
          }, null, 8, ["stations", "modal", "field"]))
        : _createCommentVNode("", true),
      (_unref(isWeatherGraph))
        ? (_openBlock(), _createBlock(FieldSelector, {
            key: 2,
            fields: selectedFields.value,
            "onUpdate:fields": _cache[5] || (_cache[5] = ($event: any) => ((selectedFields).value = $event)),
            modal: modal.value,
            "onUpdate:modal": _cache[6] || (_cache[6] = ($event: any) => ((modal).value = $event)),
            stationName: selectedStations.value[0].name,
            options: _unref(options)
          }, null, 8, ["fields", "modal", "stationName", "options"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})